import { useEffect, useState, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ErrorLabel from "../error_label";
import $ from "jquery";
import {
  actionBulkUpload,
  resetDocBulkUpload,
} from "./../../routes/app/auth/list/store/index";
import { useDropzone } from "react-dropzone";
import toast from "react-hot-toast";
import {
  TOAST_DURATION,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";

const BulkDocumentUpload = (props) => {
  const [attachment, setAttachment] = useState([]);
  const [excel, setExcel] = useState();
  const [secondInput, setSecondInput] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    setValue,
  } = useForm();

  const { BulkUploadDoc } = useSelector((state) => ({
    ...state.listStore,
  }));

  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
      setAttachment([]);
      setExcel(null);
    }
  };
  useEffect(initialRender, [props.show]);

  useEffect(() => {
    if (BulkUploadDoc) {
      dispatch(resetDocBulkUpload());
      if (BulkUploadDoc.status) {
        !excel && attachment && setSecondInput(true);
        toast.success(BulkUploadDoc.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });

        excel &&
          (() => {
            setSecondInput(false);
            props.handleClose();
          })();
      } else {
        toast.error(BulkUploadDoc?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [BulkUploadDoc]);

  const onDrop = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment.length < 100) {
      setAttachment([...attachment, ...acceptedFiles]);
    } else {
    }
  });

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: {
      doc_type: [".txt, .pdf, .doc, .docx, .jpeg, .jpg, .png, .xls, .xlsx "],
    },
    multiple: true,
    maxFiles: 100,
    maxSize: 5242880,
    onDrop,
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <ul className="danger" style={{ paddingInlineStart: "0px" }}>
      {errors.map((e) => (
        <li key={e.code}>{e.message}</li>
      ))}
    </ul>
  ));

  const removeFile = (file) => () => {
    const newFiles = [...attachment];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment(newFiles);
  };

  const removeAll = () => {
    setAttachment([]);
  };
  const thumbs = attachment?.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  const onSubmit = (data) => {
 
    if (secondInput) {
      dispatch(actionBulkUpload({
        input: { parent: "policy", isPolicynoDocumentnameMapping: true },
        files: excel !== null ? [{ name: "file", value: excel[0] }] : [],
      }));
    } else if (!secondInput) {
      if (attachment.length > 0) {
        dispatch(actionBulkUpload({
          input: { parent: "policy" },
          files: attachment.map(objImage => objImage !== null ? { name: "file", value: objImage } : null).filter(Boolean),
        }));
      } else {
        $("#document-required").removeClass("d-none");
      }
    }
  };
  

  return (
    <>
      <div
        class="modal fade show"
        id="bulk"
        tabindex="-1"
        aria-labelledby="bulkUploadDocument"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="bulkUploadDocument">
                Bulk Upload
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleClose();
                }}
              ></button>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-12">
                  <form
                    noValidate
                    autoComplete="Off"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="form-body">
                      <div className="row mb-3">
                        {!secondInput ? (
                          <div className="col-12 mt-4">
                            <div
                              {...getRootProps({ className: "dropzone" })}
                              className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                            >
                              <span className="badge bg-primary rounded p-2">
                                <input
                                  accept=""
                                  name="file"
                                  {...getInputProps()}
                                />
                                <i className="fa fa-plus"/>
                              </span>{" "}
                              <span>Add files</span>
                            </div>
                            <span
                              id="document-required"
                              className="d-none  text-danger fs-7 mx-auto "
                            >
                              {" "}
                              Document is required
                            </span>
                            {thumbs}
                            {attachment.length > 100 && (
                              <button
                                type="btn"
                                className="btn btn-primary rounded mt-4"
                                onClick={(e) => {
                                  e.preventDefault();
                                  removeAll();
                                }}
                              >
                                Remove All
                              </button>
                            )}
                            {fileRejectionItems}
                          </div>
                        ) : (
                          <div className="col-12 mt-3">
                            {/* <div className="col-4 text-center"> */}
                            <label htmlFor="formFile" className="form-label">
                              Attachment<span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="file"
                              accept=".xlsx,.xls"
                              name="file"
                              {...register("file", {
                                required: "This is required.",
                                // validate: {
                                //   lessThan20MB: (file) =>
                                //     !file ||
                                //     file.size <= 20971520 ||
                                //     "Max size for the file is 20MB",
                                // },
                              })}
                              onChange={(event) => {
                                setExcel(event.target.files);
                              }}
                            />
                            {errors.file && (
                              <ErrorLabel message={errors.file?.message} />
                            )}
                          </div>
                        )}

                        {/* </div> */}
                      </div>
                    </div>
                    <div className="form-actions border-0 float-none mt-1">
                      <button
                        id="edit_customer"
                        className="btn btn-primary shadow round text-uppercase me-2"
                        type="submit"
                      >
                        <div className="d-flex align-items-center">
                          Submit
                          <span
                            id="edit_customer-loader"
                            className="spinner-border spinner-border-sm ml-half d-none"
                          ></span>
                        </div>
                      </button>
                      <button
                        className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                        onClick={(event) => {
                          props.handleClose();
                          event.preventDefault();
                        }}
                      >
                        {" "}
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BulkDocumentUpload;
